const style = {
  paddings: {
    pt64: {
      paddingTop: '64px',
    },
  },
  container: {
    maxSize: 'lg',
  },
  title: {
    variant: 'h4',
  },
  card: {
    sx: { margin: '32px 0px' },
  },
  box: {
    display: 'flex',
    alignItems: 'center',
  },
  boxMain: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  gapBox: {
    gap: '15px',
  },
} as const;

export default style;
